import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Paper, Typography, Grid } from '@material-ui/core'
import { Breakpoint } from 'react-socks'


const staticHeaderStyles = makeStyles(theme => ({
    mainFeaturedPost: {
      position: 'relative',
      backgroundColor: theme.palette.grey[800],
      color: theme.palette.common.white,
      marginBottom: theme.spacing(4),
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    },
    overlay: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: 0,
      left: 0,
      backgroundColor: 'rgba(0,0,0,.3)',
    },
    mainFeaturedPostContent: {
      cursor: 'pointer',
      position: 'relative',
      padding: theme.spacing(3),
      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(6),
        paddingRight: 0,
      },
    },
  }));

const PageHeader = ({onClick, text, image, Tag}) => {
    const classes = staticHeaderStyles()
    
    return <Breakpoint medium up>
        <Paper 
            className={classes.mainFeaturedPost}
            style={{ backgroundImage: `url(${image})` }} 
            onClick={onClick}
        >
            <div className={classes.overlay} />
            <Grid container>
                <Grid item md={6}>
                    <div className={classes.mainFeaturedPostContent}>
                        <Typography 
                            component='h1' 
                            variant='h3' 
                            color='inherit'
                            gutterBottom>
                                Welcome to Succotash
                        </Typography>
                        <Typography
                            variant='h5'
                            color='inherit'
                            paragraph>
                                {text}
                        </Typography>
                        { Tag ? <Tag /> : null }
                    </div>
                </Grid>
            </Grid>
        </Paper>
    </Breakpoint>
}

export default PageHeader